import { Card, Chip, Tooltip, Typography } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Billing_Type_Enum } from '@kheops/graphql';
import WeightIcon from '../assets/icons/weight.svg?react';

interface BillingTypeCardProps {
  billingType: Billing_Type_Enum;
  inlineVersion?: boolean;
}

interface BillingTypeInformation {
  title: string;
  helperText: string;
  icon: ReactElement;
}

const billingTypeToInformationMap = new Map<Billing_Type_Enum, BillingTypeInformation>([
  [Billing_Type_Enum.Fixed, { title: 'products:billed_per_unit', helperText: 'products:billed_per_unit_helper', icon: <ReceiptIcon /> }],
  [Billing_Type_Enum.WeightDependent, { title: 'products:billed_per_weight', helperText: 'products:billed_per_weight_helper', icon: <WeightIcon /> }],
]);

export default function BillingTypeCard({ billingType, inlineVersion }: BillingTypeCardProps): React.JSX.Element {
  const { t } = useTranslation(['products']);
  const billingTypeInformation = billingTypeToInformationMap.get(billingType);

  return (
    <Tooltip title={t(billingTypeInformation!.helperText)}>
      {inlineVersion
        ? (
          <Chip
            variant="tag"
            color="primaryContainer"
            icon={billingTypeInformation!.icon}
            label={t(billingTypeInformation!.title)}
          />
        )
        : (
          <Card
            sx={{
              width: 128,
              height: 84,
              p: 0,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.5,
              color: (theme) => theme.palette.onSurface.main,
              backgroundColor: (theme) => theme.palette.surfaceContainer.main,
            }}
          >
            {billingTypeInformation!.icon}
            <Typography variant="bodyMedium">{t(billingTypeInformation!.title)}</Typography>
          </Card>
        )}
    </Tooltip>
  );
}
